import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getRoleTableData, removeMultipleRole, getRolePermission, removeRoleById, updateRolePermission } from "@/api/system/role";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
import roleFormDialog from "@/components/dialog/roleManage/index.vue";
import userPermissionType from "@/components/dialog/roleManage/userPermissionType.vue";
import { fetchMenuTree } from "@/api/admin/menu";
import { excelExport } from "@/api/importAndExport/excelApi";
import importExcel from "@/components/dialog/deptManage/importExcel.vue";
export default {
  name: "roleManage",
  data: function data() {
    return {
      tableLoading: false,
      roleName: "",
      multipleSelection: [],
      current: 1,
      pageSize: 10,
      userData: {
        data: [],
        total: 0,
        pageSize: ""
      },
      activeName: "0",
      dealRoleType: dealRoleType,
      dealRoleTypeData: dealRoleTypeData,
      stringToArray: stringToArray,
      permissionDialog: false,
      routeList: [],
      props: {
        label: "label",
        disabled: function disabled(data) {
          if (data.isShow == 1) {
            return true;
          }

          return false;
        }
      },
      checkedArr: [],
      checkStrictly: false,
      roleId: "",
      permissionLoading: false,
      routeLoading: false,
      uplodData: {
        state: false,
        type: ""
      },
      routerData: []
    };
  },
  components: {
    roleFormDialog: roleFormDialog,
    userPermissionType: userPermissionType,
    importExcel: importExcel
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userMenus", "roleTypeData", // "dialogTittle",
  "userPermissionTypeDialog", "defaultCheckedArray"])), {}, {
    isdisabled: function isdisabled() {
      return this.multipleSelection.length > 0 ? false : true;
    }
  }),
  watch: {},
  created: function created() {
    this.setDialogVisible(false);
    this.setPermissionDialog(false);
    this.getTableData();
    this.$store.dispatch("GetUserMenu").then(function (data) {});
    this.routerData = this.$store.getters.userData.routerData;
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setDialogVisible: "setDialogVisible",
    setPermissionDialog: "setPermissionDialog",
    setCurrentRowData: "setCurrentRowData",
    setRoleFormData: "setRoleFormData",
    // clearRoleFormData: "clearRoleFormData",
    setDialogTittle: "setDialogTittle",
    setRoleFormDialogStatus: "setRoleFormDialogStatus",
    setPromptType: "setPromptType",
    // setStatus: "setStatus",
    setCurrentRoleId: "setCurrentRoleId",
    setPromptTittle: "setPromptTittle",
    setAddRoleFormData: "setAddRoleFormData",
    clearDefaultChecked: "clearDefaultChecked",
    setDefaultChecked: "setDefaultChecked"
  })), {}, {
    isAdmin: function isAdmin() {
      return (this.$store.getters.userData.roleCodes || []).includes("ROLE_ADMIN");
    },
    // 下载模板
    dowTemplate: function dowTemplate() {
      var _this = this;

      this.$DownLoad("/admin/excel/download?type=role", null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    uploading: function uploading() {
      this.uplodData.state = true;
      this.uplodData.type = "role";
    },
    closeUplod: function closeUplod(val) {
      this.uplodData.state = val;
      this.getTableData();
    },
    downloadExcel: function downloadExcel() {
      var _this2 = this;

      this.$DownLoad(excelExport("role"), null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this2.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this2.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    handleClick: function handleClick(tab, event) {
      this.current = 1;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.current = val;
      this.getTableData();
    },
    // 设置表格行不可选
    checkSelectable: function checkSelectable(row, index) {
      if (row.sysFlag == 0) {
        return false;
      }

      return true;
    },
    getTableData: function getTableData() {
      var _this3 = this;

      this.tableLoading = true;
      var params = {
        size: this.pageSize,
        current: this.current,
        type: this.activeName
      };

      if (this.roleName) {
        params.keywords = this.roleName;
      }

      getRoleTableData(params).then(function (res) {
        if (res.data.code == 0) {
          _this3.setUserData(res.data.data);
        } else {
          _this3.$message.error(res.data.msg);
        }
      });
    },
    setUserData: function setUserData(data) {
      var _this4 = this;

      this.userData.total = data.total;
      this.userData.data = data.records;
      this.tableLoading = false;
      this.userData.data.forEach(function (item, index) {
        _this4.userData.data[index].dealMenus = _this4.stringToArray(item.menus);
      }); //   this.userData.pageSize = this.initpage.pageSize;
    },
    // 查看角色
    viewDetail: function viewDetail(params) {
      this.setCurrentRowData(params);
      this.setRoleFormData(params);
      this.setDialogVisible(true);
      this.setDialogTittle("角色详情");
      this.setRoleFormDialogStatus("view");
    },
    // 修改角色
    edit: function edit(params) {
      this.setAddRoleFormData();
      this.setRoleFormData(params);
      this.setDialogVisible(true);
      this.setDialogTittle("编辑");
      this.setRoleFormDialogStatus("edit");
    },
    // 添加角色
    handleAdd: function handleAdd() {
      this.setAddRoleFormData(Number(this.activeName)); // this.clearRoleFormData(this.activeName);

      this.setDialogVisible(true);
      this.setDialogTittle("新增");
      this.setRoleFormDialogStatus("add");
    },
    // 批量删除
    handleDelete: function handleDelete() {
      var _this5 = this;

      var that = this;

      if (this.multipleSelection.length > 0) {
        this.$confirm("确定删除选中的角色？", "提示", {
          type: "warning"
        }).then(function () {
          var idArr = _this5.multipleSelection.map(function (item) {
            return item.roleId;
          });

          removeMultipleRole({
            idArr: idArr
          }).then(function (res) {
            if (res.data.code == 0) {
              _this5.$message.success("删除成功");

              if (_this5.userData.data.length === idArr.length && _this5.current > 1) {
                _this5.userData.total -= 1;
                _this5.current -= 1;
              }

              _this5.getTableData();
            } else {
              _this5.$alert(res.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            }
          }).catch(function (err) {
            _this5.$message.error("删除失败");
          });
        });
      } else {
        this.$Message.destroy();
        this.$Message.warning("请选择目标项");
      }
    },
    // 单个删除
    deleteRole: function deleteRole(row) {
      var _this6 = this;

      this.$confirm("\u786E\u5B9A\u5220\u9664".concat(row.roleName, "\uFF1F"), "提示", {
        type: "warning"
      }).then(function () {
        removeRoleById(row.roleId).then(function (res) {
          if (res.data.code == 0) {
            _this6.$message.success("删除成功");

            if (_this6.userData.data.length === 1 && _this6.current > 1) {
              _this6.userData.total -= 1;
              _this6.current -= 1;
            }

            _this6.getTableData();
          } else {
            _this6.$alert(res.data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        });
      }).catch(function (err) {
        _this6.$message.error("删除失败");
      });
    },
    search: function search() {
      this.current = 1;
      this.getTableData();
    },
    clearSearch: function clearSearch() {
      this.roleName = "";
      this.getTableData();
    },
    changePermission: function changePermission(row) {
      this.fetchRouteList();
      this.permissionDialog = true;
      this.$nextTick(function () {
        //Dom更新完毕
        this.$refs.tree.setCheckedKeys([]);
      });
      this.fetchRoleForRouteList(row);
      this.roleId = row.roleId;
    },
    // 根据角色id查询拥有的路由列表
    fetchRoleForRouteList: function fetchRoleForRouteList(row) {
      var _this7 = this;

      this.permissionLoading = true;
      this.checkStrictly = true;
      getRolePermission(row).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          // 设置勾选
          // this.strictly = true;
          _this7.$nextTick(function () {
            console.log(data.data, "data.data");

            _this7.$refs.tree.setCheckedKeys(data.data); // data.data.forEach(i=>{
            //   this.$refs.tree.setChecked(i,true,false);
            // })


            _this7.$forceUpdate(); // this.$refs.tree.setCheckedKeys([1060,1059]);
            // this.strictly = false;
            // this.checkStrictly = true

          });
        }

        _this7.permissionLoading = false;
      }).catch(function () {
        _this7.permissionLoading = false;
      });
    },
    changeUser: function changeUser(row) {
      this.setCurrentRoleId(row.roleId);
      this.setPermissionDialog(true);
      this.setPromptTittle("\u3010".concat(row.roleName, "\u3011\u9009\u62E9\u7528\u6237"));
      this.setPromptType("selectUser");
      this.$refs.userPermissionType.selectUser.current = 1;
      this.$refs.userPermissionType.getRoleUsersData();
    },
    changeUserType: function changeUserType(row) {
      this.setCurrentRoleId(row.roleId);
      this.setPermissionDialog(true);
      this.setPromptTittle("\u3010".concat(row.roleName, "\u3011\u9009\u62E9\u7528\u6237\u7C7B\u578B"));
      this.setPromptType("selectUserType");
      this.clearDefaultChecked();
      this.$refs.userPermissionType.utypesArray = [];
      this.$refs.userPermissionType.getRoleUserTypesData();
    },
    // 获取所有的路由树状结构
    fetchRouteList: function fetchRouteList() {
      var _this8 = this;

      this.routeLoading = true;
      fetchMenuTree().then(function (_ref2) {
        var data = _ref2.data;
        _this8.routeList = data.data;
        _this8.routeLoading = false;
      }).catch(function () {
        _this8.routeLoading = false;
      });
    },
    // 保存修改
    updata: function updata() {
      var _this9 = this;

      var arr = this.$refs.tree.getCheckedNodes(false, true);
      this.permissionLoading = true;
      var roleId = this.roleId;
      var menuIds = arr.map(function (val) {
        return val.id;
      });
      var params = {
        roleId: roleId,
        menuIds: menuIds
      };
      updateRolePermission(params).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this9.$message.success("修改权限成功");

          _this9.permissionDialog = false;
        }

        _this9.permissionLoading = false;
      }).catch(function () {
        _this9.permissionLoading = false;
      });
    },
    checkSelected: function checkSelected(val) {
      this.checkStrictly = false;
    }
  })
};